/**
 * NATSU Intelligence — investor-demo analytics stub.
 *
 * Emits a CustomEvent per tracked interaction so a proper analytics
 * provider can be wired later behind a consent mechanism. NO personal
 * form information (name, email, company, role, use case) is ever
 * passed through this function.
 */
const ALLOWED = new Set([
  "request_pilot_clicked",
  "explore_platform_clicked",
  "investor_enquiries_clicked",
  "form_started",
  "form_submit_success",
  "form_submit_failed",
  "privacy_policy_opened",
  "terms_of_use_opened",
]);

export function track(event) {
  if (!ALLOWED.has(event)) return;
  try {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("natsu:analytics", { detail: { event } }));
    }
  } catch (_e) {
    // Analytics must never surface errors to the visitor.
  }
}
